
import anamnesis        from "./anamnesis/anamnesis";
import semiologias      from "./semiologias/semiologias";
import signosVitales    from "./signosVitales/signosVitales";
import receta           from "./receta/receta";
import imagenes         from "./imagenes/imagenes";
import laboratorios     from "./laboratorios/laboratorios";
import descanso         from "./descanso/descanso";
import docAs400         from "./docAs400/docAs400";
import terapias         from "./terapias/terapias";
import derivacionesInterconsultas from "./derivacionesInterconsultas/derivacionesInterconsultas"; 
import historialRecetas from "./historialRecetas";
import encuesta         from "./encuesta/encuesta";

export default {
  state: {
    dataCita: null,
    pacienteSignature: null,
  },

  mutations: {

    setDataCita(state, data) {
      state.dataCita = data;
    },

    setPacienteSignature(state, data) {
      state.pacienteSignature = data
    },

    resetAtencionCita(state){
      state.dataCita = null;
      state.pacienteSignature = null
    },

  },

  modules: {
    anamnesis,
    semiologias,
    signosVitales,
    receta,
    imagenes,
    laboratorios,
    descanso,
    docAs400,
    terapias,
    historialRecetas,
    encuesta,
    derivacionesInterconsultas
  },
};
